import { TFileId, IFileData, TLanguageIDs, IMenuTranslation, ICreateVideo, IItemForGetShortInfo } from 'types';
import { TVisibleForm, TSelectedItem, TTypeOfModalWindow } from './createVideoContext';

export enum CreateVideoActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE_ID = 'SET_FILE_ID',
	SET_FETCHED_STUDIOS = 'SET_FETCHED_STUDIOS',
	SET_ID_STUDIO = 'SET_ID_STUDIO',
	REFETCH_STUDIOS = 'REFETCH_STUDIOS',
	CHANGE_NAME_OF_VIDEO = 'CHANGE_NAME_OF_VIDEO',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	CHANGE_FILE_DATA = 'CHANGE_FILE_DATA',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_IDs_LANGUAGES = 'SET_IDs_LANGUAGES',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVisibleForm {
	type: CreateVideoActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TVisibleForm;
	};
}

interface ISetFileId {
	type: CreateVideoActionTypes.SET_FILE_ID;
	payload: {
		fileId: TFileId;
	};
}

interface ISetFetchedStudios {
	type: CreateVideoActionTypes.SET_FETCHED_STUDIOS;
	payload: {
		fetchedStudios: IItemForGetShortInfo[];
	};
}

interface ISetIDStudio {
	type: CreateVideoActionTypes.SET_ID_STUDIO;
	payload: {
		IDSelectedStudio: TSelectedItem;
	};
}

interface IRefetchStudios {
	type: CreateVideoActionTypes.REFETCH_STUDIOS;
	payload: {
		needRefetchStudios: boolean;
	};
}

interface IChangeNameOfVideo {
	type: CreateVideoActionTypes.CHANGE_NAME_OF_VIDEO;
	payload: {
		nameOfVideo: string;
	};
}

interface ISetFetchedCategories {
	type: CreateVideoActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		fetchedCategories: IItemForGetShortInfo[];
	};
}

interface ISetIDSelectedCategory {
	type: CreateVideoActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: TSelectedItem;
	};
}

interface IChangeFileData {
	type: CreateVideoActionTypes.CHANGE_FILE_DATA;
	payload: {
		fileData: IFileData;
	};
}

interface ISetFetchedLanguages {
	type: CreateVideoActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		fetchedLanguages: IItemForGetShortInfo[];
	};
}

interface ISetIDsLanguages {
	type: CreateVideoActionTypes.SET_IDs_LANGUAGES;
	payload: {
		IDsSelectedLanguages: TLanguageIDs[];
	};
}

interface ISetTranslationTab {
	type: CreateVideoActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: TLanguageIDs | null;
	};
}

interface IChangeTranslation {
	type: CreateVideoActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface ISetDataForSubmit {
	type: CreateVideoActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateVideo | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateVideoActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IResetSelectedControls {
	type: CreateVideoActionTypes.RESET_FIELDS;
}

export type TCreateVideoAction =
	| IChangeVisibleForm
	| ISetFileId
	| ISetFetchedStudios
	| ISetIDStudio
	| IRefetchStudios
	| IResetSelectedControls
	| IChangeNameOfVideo
	| ISetFetchedCategories
	| ISetIDSelectedCategory
	| IChangeFileData
	| ISetFetchedLanguages
	| ISetIDsLanguages
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
